import {
  DistributionNavEnum,
  OtaSyncOptions,
} from '@new/domains/properties/screens/propertyDistributionChannels/DistributionChannels.types'

interface SyncOption {
  label: string
  value: OtaSyncOptions
}

// Define all available sync options
const syncOptions: Record<OtaSyncOptions, SyncOption> = {
  [OtaSyncOptions.availability]: { label: 'Availability', value: OtaSyncOptions.availability },
  [OtaSyncOptions.amenities]: { label: 'Amenities', value: OtaSyncOptions.amenities },
  [OtaSyncOptions.photos]: { label: 'Photos', value: OtaSyncOptions.photos },
  [OtaSyncOptions.listingContent]: { label: 'Listing Content', value: OtaSyncOptions.listingContent },
  [OtaSyncOptions.rooms]: { label: 'Rooms', value: OtaSyncOptions.rooms },
  [OtaSyncOptions.pricing]: { label: 'Pricing', value: OtaSyncOptions.pricing },
  [OtaSyncOptions.seasonalDiscounts]: { label: 'Seasonal Discounts', value: OtaSyncOptions.seasonalDiscounts },
  [OtaSyncOptions.feesAndTaxes]: { label: 'Fees and Taxes', value: OtaSyncOptions.feesAndTaxes },
}

export const otaSyncOptionsByChannel = {
  [DistributionNavEnum.airbnb]: [
    syncOptions[OtaSyncOptions.amenities],
    syncOptions[OtaSyncOptions.availability],
    syncOptions[OtaSyncOptions.feesAndTaxes],
    syncOptions[OtaSyncOptions.listingContent],
    syncOptions[OtaSyncOptions.photos],
    syncOptions[OtaSyncOptions.pricing],
    syncOptions[OtaSyncOptions.rooms],
    syncOptions[OtaSyncOptions.seasonalDiscounts],
  ],
  [DistributionNavEnum.rentalsUnited]: [
    syncOptions[OtaSyncOptions.amenities],
    syncOptions[OtaSyncOptions.availability],
    syncOptions[OtaSyncOptions.feesAndTaxes],
    syncOptions[OtaSyncOptions.listingContent],
    syncOptions[OtaSyncOptions.photos],
    syncOptions[OtaSyncOptions.pricing],
    syncOptions[OtaSyncOptions.rooms],
  ],
  [DistributionNavEnum.vrbo]: [
    syncOptions[OtaSyncOptions.availability],
    syncOptions[OtaSyncOptions.feesAndTaxes],
    syncOptions[OtaSyncOptions.pricing],
    syncOptions[OtaSyncOptions.seasonalDiscounts],
  ],
  [DistributionNavEnum.yieldPlanet]: [
    syncOptions[OtaSyncOptions.availability],
    syncOptions[OtaSyncOptions.pricing],
  ],
}

export const syncLimitationWarningByChannel: Partial<Record<string, string>> = {
  [DistributionNavEnum.vrbo]:
    'VRBO only supports syncing availability, pricing, taxes, and seasonal discounts. Other sync options are not available for this channel.',
  [DistributionNavEnum.yieldPlanet]:
    'Yield Planet only supports syncing availability and pricing.',
}
